import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/scroll";

export const FloatingWhatsApp = () => (
  <a
    data-testid="whatsapp-float-btn"
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with the practice on WhatsApp"
    className="fixed bottom-6 right-6 z-50 group"
  >
    <span className="absolute inset-0 rounded-full bg-pawc-teal/40 animate-ping [animation-duration:3s]" aria-hidden="true" />
    <span className="relative flex w-14 h-14 rounded-full bg-pawc-teal group-hover:bg-pawc-deep text-pawc-sand items-center justify-center shadow-[0_15px_30px_-10px_rgba(2,89,85,0.5)] transition-colors duration-300">
      <MessageCircle size={24} strokeWidth={1.5} />
    </span>
  </a>
);
